export const GET_CN_FLASHCARDS = 'GET_CN_FLASHCARDS';

export const getCnFlashCards = (cardName) => ({
    type: GET_CN_FLASHCARDS,
    cardName
})